import { CheckIcon } from "@heroicons/react/solid";
import { useState } from "react";
import { useNavigate } from "react-router-dom";
import { useListAllPricingQuery } from "../../utils/api/pricing/pricingApi";

const Pricing = () => {
  const [tiers, setTiers] = useState([
    {
      name: "Basic",
      price_month: 0,
      price_year: 0,
      description: "All the basics for using lawrify",
      features: [
        "Create your smart ID profiles",
        "Create accounts and register for events",
      ],
    },
  ]);
  const [userTierActive, setUserTierActive] = useState(true);
  const navigate = useNavigate();
  const pricingPlans = {
    user: [
      {
        name: "Basic",
        price_month: 0,
        price_year: 0,
        description: "All the basics for using lawrify",
        includedFeatures: [
          "Create your smart ID profiles",
          "Create accounts and register for events",
        ],
      },
    ],
    branch: [
      {
        name: "Basic",
        price_month: 5000,
        price_year: 50000,
        description: "Ideal for branch / association with up to 1000 members",
        includedFeatures: [
          "Manage up to 1000 users",
          "Create up to 5 events",
          "Upload event documents",
        ],
      },
      {
        name: "Sliver",
        price_month: 7000,
        price_year: 70000,
        description: "Ideal for branch / association with up to 5000 members",
        includedFeatures: [
          "Manage up to 5000 users",
          "Create up to 10 events",
          "Upload event documents",
          "Automate smart ID profile verification",
          "Process online payments for events",
        ],
      },
      {
        name: "Gold",
        price_month: 10000,
        price_year: 100000,
        description: "Ideal for branch / association with up to 20000 members",
        includedFeatures: [
          "Manage up to 20000 users",
          "Create up to 20 events",
          "Upload event documents",
          "Automate smart ID profile verification",
          "Process online payments for events",
        ],
      },
    ],
  };

  const {
    data: pricings,
    isLoading: loadingPricings,
    isError: errorPricings,
  } = useListAllPricingQuery({});
  console.log(pricings);
  return (
    <section className="bg-gray-50 dark:bg-gray-800">
      <div className="max-w-7xl mx-auto py-24 px-6 sm:px-8 xl:px-0">
        <div className="sm:flex sm:flex-col sm:align-center">
          <h2 className="text-3xl font-extrabold text-gray-900 dark:text-gray-100 sm:text-center">
            Pricing Plans
          </h2>
          <p className="mt-5 text-xl text-gray-700 dark:text-gray-200 sm:text-center">
            Lawrify is free to use for users and members. For branches and
            associations accounts, check out the pricing plan.
          </p>
          {/* <div className="relative self-center mt-6 bg-gray-100 rounded-lg p-0.5 flex sm:mt-8">
            <button
              type="button"
              className={`
            ${
              userTierActive
                ? "bg-alternate dark:bg-primary-darker "
                : "bg-alternate-light dark:bg-primary"
            }
            relative w-1/2  border-alternate-lighter text-white rounded-md shadow-sm py-2 text-sm font-medium whitespace-nowrap focus:outline-none focus:ring-2 focus:ring-alternate-lighter focus:z-10 sm:w-auto sm:px-8`}
              onClick={() => {
                setTiers(pricingPlans.user);
                setUserTierActive(true);
              }}
            >
              Users / Members
            </button>
            <button
              type="button"
              className={`
            ${
              !userTierActive
                ? "bg-alternate dark:bg-primary-darker "
                : "bg-alternate-light dark:bg-primary"
            }
            ml-0.5 relative w-1/2  border-alternate-lighter text-white rounded-md shadow-sm py-2 text-sm font-medium whitespace-nowrap focus:outline-none focus:ring-2 focus:ring-alternate-lighter focus:z-10 sm:w-auto sm:px-8`}
              onClick={() => {
                setTiers(pricingPlans.branch);
                setUserTierActive(false);
              }}
            >
              Branches / Associations
            </button>
          </div> */}
        </div>
        {loadingPricings ? (
          <div>loading prices</div>
        ) : (
          <div className="mt-12 space-y-4 sm:mt-16 sm:space-y-0 sm:gap-6 lg:max-w-4xl lg:mx-auto xl:max-w-none xl:mx-0 grid grid-cols-1 md:grid-cols-3 place-content-center">
            {pricings?.map((tier:PricingType) => (
              <div
                key={tier.id}
                className="bg-white dark:bg-gray-700 border border-gray-200 dark:border-gray-600 rounded-lg shadow-sm divide-y divide-gray-200"
              >
                <div className="p-6">
                  <h2 className="text-lg leading-6 font-medium text-gray-900 dark:text-gray-100">
                    {tier.name}
                  </h2>
                  <p className="mt-4 text-sm text-gray-700  dark:text-gray-100">
                    {tier.description}
                  </p>
                  <p className="mt-8">
                    <span className="text-4xl font-extrabold text-gray-900  dark:text-gray-100">
                      {" "}
                      &#8358; {tier.price_year}
                    </span>{" "}
                    <span className="text-base font-medium text-gray-700  dark:text-gray-100">
                      /annum
                    </span>
                  </p>
                  <button
                    onClick={()=>navigate('/auth')}
                    className="mt-8 block w-full bg-alternate dark:bg-primary-dark border border-alternate dark:border-primary rounded-md py-2 text-sm font-semibold text-white text-center hover:bg-alternate-dark dark:hover:bg-primary-light"
                  >
                    Get Started
                  </button>
                </div>
                <div className="pt-6 pb-8 px-6">
                  <h3 className="text-xs font-bold text-gray-900  dark:text-gray-100 tracking-wide uppercase">
                    What's included
                  </h3>
                  <ul className="mt-6 space-y-4">
                   
                    {(JSON.parse(tier.features)).map((feature:string) => (
                      <li key={feature} className="flex space-x-3">
                        <CheckIcon
                          className="flex-shrink-0 h-5 w-5 text-green-700  dark:text-green-400"
                          aria-hidden="true"
                        />
                        <span className="text-sm text-gray-700  dark:text-gray-100">
                          {feature}
                        </span>
                      </li>
                    ))}
                  </ul>
                </div>
              </div>
            ))}
          </div>
        )}
      </div>
    </section>
  );
};

export default Pricing;
